import { Navigate } from "react-router-dom";
import { ROLE_COMMON_CARRIER, ROLE_LOGISTIC } from "../Config/config";
import { getLocalStorageItem } from "../Helper/helper";

const PrivateLogisticRoute = ({ children }) => {
	const { role } = getLocalStorageItem("ORDER_USER_DETAILS");
    const AUTH_TOKEN = getLocalStorageItem("ORDER_AUTH_TOKEN");

	if (AUTH_TOKEN) {
		if (role == ROLE_LOGISTIC || role == ROLE_COMMON_CARRIER) {
			return children;
		} else {
			return <Navigate to="/access-denied" />;
		}
	} else {
		return <Navigate to="/login" />;
	}
};
export default PrivateLogisticRoute;
